import React from 'react';
import { Box, Grid, Slide, Typography } from '@material-ui/core';

import Spacer from '../util/Spacer';
import newsImage from '../../static/images/news.jpg';

const NEWS_TITLE = 'ÖFFNUNGSZEITEN';

const NEWS_CONTENT =
  'Geschätzte Gäste, wir haben Montag bis Freitag von 8 bis 15 Uhr geöffnet ' +
  '(Samstag, Sonntag und Feiertag geschlossen). Wählen Sie aus 6 Menüs ' +
  'zwischen 11 und 14 Uhr! Freundliche Grüße bis bald, Ihr Team vom CCG ' +
  'Meetingpoint';

const News = (): JSX.Element => {
  return (
    <Box p={4} minHeight="90vh">
      <Grid container>
        <Grid item xs={12} md={6}>
          <Slide in direction="right">
            <Box p={{ xs: 0, sm: 5 }}>
              <Typography variant="h6" align="center">
                {NEWS_TITLE}
              </Typography>
              <Spacer height={30} />
              <Typography color="textSecondary" variant="body1" align="justify">
                {NEWS_CONTENT}
              </Typography>
            </Box>
          </Slide>
        </Grid>
        <Slide in direction="left">
          <Grid
            item
            xs={12}
            md={6}
            style={{
              backgroundImage: `url(${newsImage})`,
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center center',
            }}
          />
        </Slide>
      </Grid>
    </Box>
  );
};

export default News;
